import { render, staticRenderFns } from "./IviewCascader.vue?vue&type=template&id=37616e8e&scoped=true&"
import script from "./IviewCascader.vue?vue&type=script&lang=js&"
export * from "./IviewCascader.vue?vue&type=script&lang=js&"
import style0 from "./IviewCascader.vue?vue&type=style&index=0&id=37616e8e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37616e8e",
  null
  
)

export default component.exports